function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", {
  id: "proFormations-logo-svg_svg__defs7"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "proFormations-logo-svg_svg__clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "proFormations-logo-svg_svg__rect4",
  fill: "none",
  d: "M346.75-149.68h190v103.37h-190z"
})), /*#__PURE__*/React.createElement("style", {
  id: "style2"
}, ".proFormations-logo-svg_svg__cls-3{fill:#484972}.proFormations-logo-svg_svg__cls-4{fill:#ff435f}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "proFormations-logo-svg_svg__cls-3",
  d: "M224.37 49v17.1h28.85v8.5h-28.85v26.93H214V40.39h41.55V49z",
  id: "proFormations-logo-svg_svg__path13"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "proFormations-logo-svg_svg__cls-3",
  d: "M283.69 102.19c-19.2 0-24.17-12.13-24.17-25.12S264.59 52 283.78 52c19 0 24.26 12.23 24.26 25.12-.04 13.04-5.25 25.07-24.35 25.07zm.09-41.93c-11.36 0-13.84 7.64-13.84 16.81s2.48 16.81 13.75 16.81c11.46 0 13.94-7.35 13.94-16.81 0-9.07-2.29-16.81-13.85-16.81z",
  id: "proFormations-logo-svg_svg__path15"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "proFormations-logo-svg_svg__cls-3",
  d: "M338.52 60.83c-10.22 0-12.23 5.64-12.23 13.57v27.12h-10.22v-48.9h5.45l2.39 6.78c1.52-3.25 6.2-7.45 15.75-7.45h1.63V61c-.96 0-1.91-.17-2.77-.17z",
  id: "proFormations-logo-svg_svg__path17"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "proFormations-logo-svg_svg__cls-3",
  d: "M404 101.52V72.2c0-6.88-1.24-11.65-9.07-11.65-7.64 0-9.27 4.68-9.27 11.65v29.32h-10.27V72.2c0-6.88-1.24-11.65-9.08-11.65-7.64 0-9.36 4.68-9.36 11.65v29.32h-10.22v-48.9h5.54l2.3 6.3c1.52-3.15 5.92-7 15-7 7.26 0 11.37 2.77 13.47 7.55C384.46 56.06 389 52 398.21 52c13.38 0 16.15 9.36 16.15 20.82v28.75z",
  id: "proFormations-logo-svg_svg__path19"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "proFormations-logo-svg_svg__cls-3",
  d: "M461.73 101.52l-2.1-7.35c-2.29 3.82-9.07 8-19.2 8-10.5 0-18.91-4.68-18.91-15 0-9 6.4-13.08 20.35-14.42l15.37-1.52c-.28-7.07-2.86-11.18-12.7-11.18-9.07 0-11.55 3.63-11.55 9.74l-9.94.1c0-10.13 4.2-18 21.39-18 20 0 22.83 8.6 22.83 21.78v27.79zM457.24 79l-13.85 1.53c-8.5.95-11.36 2.77-11.36 6.59 0 4.49 3.82 7.07 11 7.07 9 0 14.23-5.16 14.23-13.66z",
  id: "proFormations-logo-svg_svg__path21"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "proFormations-logo-svg_svg__cls-3",
  d: "M487.81 60.83v26.65c0 4.59 1.91 6.69 12.51 6.21v8.21c-16.14 1-22.92-2.86-22.92-14.42V60.83h-7v-6.11l7-2.1V40.39h10.12v12.23h12.8v8.21z",
  id: "proFormations-logo-svg_svg__path23"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "proFormations-logo-svg_svg__cls-3",
  d: "M511.89 47c-4.59 0-7.55-1.25-7.55-6.12s3-6.21 7.55-6.21c4.39 0 7.25 1.25 7.25 6.21S516.28 47 511.89 47zm-5.16 54.53V52.62h10.12v48.9z",
  id: "proFormations-logo-svg_svg__path25"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "proFormations-logo-svg_svg__cls-3",
  d: "M548.85 102.19c-19.2 0-24.17-12.13-24.17-25.12S529.75 52 548.94 52c19 0 24.26 12.23 24.26 25.12 0 13.04-5.2 25.07-24.35 25.07zm.09-41.93c-11.36 0-13.85 7.64-13.85 16.81s2.49 16.81 13.76 16.81c11.46 0 13.94-7.35 13.94-16.81 0-9.07-2.29-16.81-13.85-16.81z",
  id: "proFormations-logo-svg_svg__path27"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "proFormations-logo-svg_svg__cls-3",
  d: "M616 101.52V74.3c0-8.69-1.53-13.85-11.94-13.85s-12.6 5.06-12.6 13.85v27.22h-10.23v-48.9h5.54l2.29 6.88c1.62-3.35 6.78-7.55 17.86-7.55 16 0 19.2 9.36 19.2 23.21v26.36z",
  id: "proFormations-logo-svg_svg__path29"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "proFormations-logo-svg_svg__cls-3",
  d: "M656.3 102.19c-16.52 0-23.59-6.49-23.59-18.91h10c0 6.69 3.82 10.79 13.37 10.79 8.69 0 11.47-3.24 11.65-6.11.29-10.6-34.09-3.53-34.09-21 0-8.6 5.92-15 21.39-15 15.86 0 21.49 7.45 21.49 18.24H667c-.38-6.4-3.25-10.31-12.22-10.31-8.22 0-11 3-11 6.21 0 9.45 34 3 34 21.3.02 7.15-6 14.79-21.48 14.79z",
  id: "proFormations-logo-svg_svg__path31"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "proFormations-logo-svg_svg__cls-4",
  d: "M71.06 82.87h-8.59v19.32H46.82V40.36h23.37c24.54 0 26.38 13.14 26.38 21.55s-1.16 20.96-25.51 20.96zm-.48-29.76h-8.11V70.7h8.11c8.89 0 10.14-4.93 10.14-8.79s-1.25-8.8-10.14-8.8z",
  id: "proFormations-logo-svg_svg__path33"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "proFormations-logo-svg_svg__cls-4",
  d: "M117.75 77v25.21h-15.07V52.92h6.86l3.38 7.73c2.32-3.38 7.54-9.66 17.88-8.5v13.14c-11.31-1.16-13.05 5.12-13.05 11.71z",
  id: "proFormations-logo-svg_svg__path35"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "proFormations-logo-svg_svg__cls-4",
  d: "M157.85 103.06c-19.61 0-24.64-12.85-24.64-25.6s5.22-25.41 24.73-25.41 24.73 12.56 24.73 25.41c0 13.04-5.31 25.6-24.82 25.6zm.09-38.45c-7.73 0-10.14 5-10.14 12.85s2.51 13 10 13c7.82 0 10.33-5 10.33-13 .05-7.73-2.13-12.85-10.19-12.85z",
  id: "proFormations-logo-svg_svg__path37"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "proFormations-logo-svg_svg__cls-4",
  d: "M46.82 112.32h135.85v6.86L46.82 128z",
  id: "proFormations-logo-svg_svg__path39"
});

function SvgProFormationsLogoSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "proFormations-logo-svg_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 724 156",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

export default SvgProFormationsLogoSvg;